import { MortgageType } from "@shared/constants/schema";

import { newMortgageChart } from "./new-mortgage-chart";
import { refinanceChart } from "./refinance-chart";
import { renewalChart } from "./renewal-chart";

import type { NewMortgageStep } from "./new-mortgage-chart";
import type { RefinanceStep } from "./refinance-chart";
import type { RenewalStep } from "./renewal-chart";

export const charts = {
  NEW: newMortgageChart,
  RENEWAL: renewalChart,
  TRANSFER: renewalChart,
  REFINANCE: refinanceChart,
} satisfies Record<MortgageType, unknown>;

export type Charts = typeof charts;

export type StepByType<MT extends MortgageType> = Exclude<
  keyof Charts[MT],
  "INITIAL"
>;

export { NewMortgageStep, RefinanceStep, RenewalStep };
